// src/hooks/useAuctionSocket.ts
import { useCallback, useEffect, useState } from 'react';
import { User, UserType } from '../utilities/types';
import { getUserApi, getUsersApi } from '../apis/admin';

const useUserHook = (userType: UserType, userId?: number) => {
  const [userDetail, setUserDetail] = useState<User | null>(null);
  const [users, setUsers] = useState<User[]>([]);

  const getUsers = useCallback(async () => {
    const payload = {
      filters: { user_type: userType },
      page: 1,
      limit: 0,
    };
    getUsersApi(payload)
      .then((response: any) => {
        if (response.status) {
          setUsers(response.data.items);
        }
      })
      .catch((err) => {
        console.log('============users fetching error', err);
      });
  }, [userType]);

  useEffect(() => {
    if (!userId) {
      return;
    }
    getUserApi(userId as number)
      .then((response: any) => {
        if (response.status) {
          setUserDetail(response.data);
        }
      })
      .catch((err) => {
        console.log('============user detail fetching error', err);
      });
  }, [userId]);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  return { users, userDetail };
};

export default useUserHook;
